import React from 'react';
import eng from '../../engineer.png';

const text = [
    "هيعرفك يعنى ايه صيانة",
    "أعلى خبرات وشهادات معتمدة و أقل مصنعيات",
    "أحدث اجهزة الكومبيوتر لكشف الأعطال والفحص",
    "أحدث أجهزة قياس ومعدات لجميع دورات السيارات",
    "هو البيت الآمن لسيارتك"
];

class Engineer extends React.Component{

    constructor(props) {
        super(props);
    
        this.state = { currentGP: 0 , class :'fadeInDown'};
    
        this.interval = null;
    
        this.nextGP = this.nextGP.bind(this);
    }
    
    nextGP() {
        let current = this.state.currentGP;
        let next = ++current % text.length;
        this.setState({ 
            currentGP: next ,
            class :this.state.class==='fadeInDown'?'fadeInUp':'fadeInDown'
        });
    }
    
    componentDidMount() {
        this.interval = setInterval(this.nextGP, 7000);
    }
    
    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render(){
        return(
            <div className="eng-container">
                <section className="engineer wrapper lemo-font">
                    <div className="hero-text">
                        <p> المهندس : <span className={this.state.class+" animated"}>{text[this.state.currentGP]}</span></p>
                    </div>
                    <div className="img"> <img src={eng} alt="elmuhandis" className="hero"/> </div>
                </section>
            </div>    
        );
    }

}

export default Engineer;


// WEBPACK FOOTER //
// ./src/components/home/Engineer.js